import { toDayJs } from '@helpers'

const getFormattedSlotTime = (startsAt, endsAt) =>
  `${toDayJs(startsAt).format('h:mma')} - ${toDayJs(endsAt).format('h:mma')}`

export default getFormattedSlotTime
